const routes = [{
  path: '/jobnum',
  component: () => import('@/views/jobnum'),
  name: 'jobnum',
  meta: {
    title: '工号管理'
  }
}, {
  path: '/jobnum/home',
  component: () => import('@/views/jobnum/home'),
  name: 'jobnum-home',
  meta: {
    title: '保司工号'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/jobnum.js